import { isEqual } from 'lodash';
import { useCallback } from 'react';

import { BundleBasketFragment } from '@generated/gql/graphql';
import { useTrackingContext } from '@tracking/Provider/Context';
import { SignupCoreServicesEntity } from '@tracking/trackingEvents';
import { parseCoreServicesEntity } from '@tracking/utils';

const useCoreServiceTrackingContextUpdate = () => {
  const { setCoreServicesTrackingContext, coreServicesTrackingContext } =
    useTrackingContext();

  const updateCoreServiceContext = useCallback(
    (basket: Nullable<BundleBasketFragment>) => {
      if (!basket) {
        return;
      }
      const updatedContext = parseCoreServicesEntity(basket);

      if (!updatedContext) {
        return;
      }

      const context: SignupCoreServicesEntity = {
        ...coreServicesTrackingContext,
        ...updatedContext,
      };

      // Ensures that the context is not updated unnecessarily causing a re-render
      if (isEqual(updatedContext, coreServicesTrackingContext)) {
        return coreServicesTrackingContext;
      }

      setCoreServicesTrackingContext(context);

      return updatedContext;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setCoreServicesTrackingContext]
  );

  return { updateCoreServiceContext };
};

export { useCoreServiceTrackingContextUpdate };
